module.exports = __webpack_public_path__ + "static/media/ClearFilters.7683bc8a.svg";